import * as Yup from 'yup';

export const CreateEditIntegrationValidationSchema = () => {
    return Yup.object({
        apiKey: Yup.string().required('A API Key é obrigatória'),
    });
};
